<svelte:options runes={false} />
<script>
  // Cost accounting (TASK-K2T-8): turnover and fees %NAV — the two figures no other tab renders
  // (fee TOTALS live on the Execution tab; this line links there rather than duplicating tiles).
  // feeSamples disambiguates a measured zero from absence; null ratios render as — (honest absence).
  import { formatNum } from '../../../lib/lineage.js';
  import { fmtWeight } from '../../../lib/integrity.js';

  export let cost = null; // CostSummary
</script>

<div class="it-cost-tiles">
  <div class="it-cost-tile">
    <span class="it-cost-label">Traded notional</span>
    <!-- A measured 0 is a real number (fresh strategy, no fills) — only null is absence. -->
    <span class="it-cost-value num">{cost?.tradedNotional != null ? formatNum(cost.tradedNotional, 2) : '—'}</span>
  </div>
  <div class="it-cost-tile">
    <span class="it-cost-label">Turnover (÷ NAV)</span>
    <span class="it-cost-value num">{fmtWeight(cost?.turnover)}</span>
  </div>
  <div class="it-cost-tile">
    <span class="it-cost-label">Fees (n={cost?.feeSamples ?? 0})</span>
    <span class="it-cost-value num">{(cost?.feeSamples ?? 0) > 0 ? formatNum(cost.totalFees, 2) : '—'}</span>
    <span class="it-cost-sub">per-symbol fee detail lives on the Execution tab</span>
  </div>
  <div class="it-cost-tile">
    <span class="it-cost-label">Fees % NAV</span>
    <span class="it-cost-value num">{cost?.feesPctNavBps != null ? `${formatNum(cost.feesPctNavBps, 2)} bps` : '—'}</span>
  </div>
</div>

<style>
  .it-cost-tiles { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 0.5rem; }
  .it-cost-tile {
    display: flex; flex-direction: column; gap: 0.12rem;
    border: 1px solid var(--border-subtle, #1e1f22); border-radius: 6px; padding: 0.5rem 0.6rem;
    background: var(--surface-1, rgba(255, 255, 255, 0.02));
  }
  .it-cost-label { font-size: 0.62rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--text-muted, #8a8b8d); }
  .it-cost-value { font-size: 0.95rem; font-weight: 700; color: var(--text-primary, #e8e9ea); }
  .it-cost-sub { font-size: 0.6rem; color: var(--text-muted, #8a8b8d); }
  .num { font-variant-numeric: tabular-nums; }
</style>
